<script setup lang="ts">
import TheLayoutApp from "@/Layouts/TheLayoutApp.vue";
import AppPage from "@/Components/Shared/page/AppPage.vue";
import AppContainer from "@/Components/Shared/container/AppContainer.vue";
import AppHeader from "@/Components/Shared/header/AppHeader.vue";
import AppTitle from "@/Components/Shared/title/AppTitle.vue";
import AppPlaceholder from "@/Components/Shared/placeholder/AppPlaceholder.vue";
import AppLink from "@/Components/Shared/link/AppLink.vue";
import AppProductGrid from "@/Components/Shared/product/AppProductGrid.vue";
import AppDivider from "@/Components/Shared/divider/AppDivider.vue";

type Props = {
    brand: object;
    popularProducts: object;
    networkProducts?: object;
};

const {
    brand,
    popularProducts,
    networkProducts = undefined,
} = defineProps<Props>();

const breadcrumbs = [
    {
        label: "Producten",
        path: "/producten",
    },
    {
        label: "Merken",
        path: "/merken",
    },
];
</script>

<template>
    <TheLayoutApp
        :title="`${brand.data.name}`"
        :description="`Ontdek alle reviews voor ${brand.data.name} via geschreven aanbevelingen, gemaakte collecties en meer. Ontdek de kracht van collectieve aanbevelingen. Welke ${brand.data.name} zou jij aanraden?`"
        :breadcrumbs="breadcrumbs"
    >
        <AppPage size="small">
            <AppContainer size="large">
                <AppHeader>
                    <AppTitle size="large">
                        {{ brand.data.name }}
                    </AppTitle>
                </AppHeader>

                <section
                    v-if="
                        networkProducts &&
                        networkProducts.data &&
                        networkProducts.data.length
                    "
                    class="mb-12"
                >
                    <AppHeader>
                        <AppTitle
                            as="h2"
                            variant="main"
                        >
                            Aangeraden door je netwerk
                        </AppTitle>
                    </AppHeader>

                    <AppProductGrid
                        :products="networkProducts.data"
                        size="large"
                    />
                </section>

                <section>
                    <AppHeader>
                        <AppTitle
                            as="h2"
                            variant="main"
                        >
                            Trending
                        </AppTitle>
                    </AppHeader>

                    <template
                        v-if="
                            popularProducts &&
                            popularProducts.data &&
                            popularProducts.data.length
                        "
                    >
                        <AppProductGrid
                            :products="popularProducts.data"
                            size="large"
                        />

                        <AppDivider spacing="large">
                            <AppLink
                                variant="button"
                                :href="`/zoeken?brands[]=${brand.data.id}`"
                            >
                                bekijk alle producten →
                            </AppLink>
                        </AppDivider>
                    </template>
                    <AppPlaceholder v-else>
                        Nog geen producten gevonden
                    </AppPlaceholder>
                </section>
            </AppContainer>
        </AppPage>

        <!--        <template #sidebar>-->
        <!--            &lt;!&ndash;            <section v-if="moreInTheme && moreInTheme.data && Object.keys(moreInTheme.data).length" class="p-6 pb-8 bg-themeSecondary rounded-sm mt-8">&ndash;&gt;-->
        <!--            &lt;!&ndash;                <AppHeader>&ndash;&gt;-->
        <!--            &lt;!&ndash;                    <AppTitle&ndash;&gt;-->
        <!--            &lt;!&ndash;                        as="h2"&ndash;&gt;-->
        <!--            &lt;!&ndash;                        color="primary"&ndash;&gt;-->
        <!--            &lt;!&ndash;                        variant="subtitle"&ndash;&gt;-->
        <!--            &lt;!&ndash;                    >&ndash;&gt;-->
        <!--            &lt;!&ndash;                        Meer in dit thema&ndash;&gt;-->
        <!--            &lt;!&ndash;                    </AppTitle>&ndash;&gt;-->
        <!--            &lt;!&ndash;                </AppHeader>&ndash;&gt;-->

        <!--            &lt;!&ndash;                <AppBadgeGroup>&ndash;&gt;-->
        <!--            &lt;!&ndash;                    <AppBadge&ndash;&gt;-->
        <!--            &lt;!&ndash;                        v-for="category in moreInTheme.data"&ndash;&gt;-->
        <!--            &lt;!&ndash;                        :href="category.path"&ndash;&gt;-->
        <!--            &lt;!&ndash;                        size="large"&ndash;&gt;-->
        <!--            &lt;!&ndash;                        color="themeDark"&ndash;&gt;-->
        <!--            &lt;!&ndash;                    >&ndash;&gt;-->
        <!--            &lt;!&ndash;                        {{ category.name }}&ndash;&gt;-->
        <!--            &lt;!&ndash;                    </AppBadge>&ndash;&gt;-->
        <!--            &lt;!&ndash;                </AppBadgeGroup>&ndash;&gt;-->
        <!--            &lt;!&ndash;            </section>&ndash;&gt;-->
        <!--            <div class="flex flex-col gap-8">-->
        <!--                <section v-if="posts && posts.data">-->
        <!--                    <AppHeader spacing="small">-->
        <!--                        <AppTitle-->
        <!--                            as="h3"-->
        <!--                            variant="subtitle"-->
        <!--                            color="gray"-->
        <!--                        >-->
        <!--                            Posts-->
        <!--                        </AppTitle>-->
        <!--                    </AppHeader>-->

        <!--                    <AppPostList :posts="posts.data" />-->

        <!--                    <AppButton-->
        <!--                        class="mt-2"-->
        <!--                        href="/community/posts"-->
        <!--                        as="Link"-->
        <!--                        color="gray"-->
        <!--                        size="full small"-->
        <!--                    >-->
        <!--                        Alle posts →-->
        <!--                    </AppButton>-->
        <!--                </section>-->

        <!--                <section v-if="users && users.data">-->
        <!--                    <AppHeader>-->
        <!--                        <AppTitle-->
        <!--                            as="h3"-->
        <!--                            variant="subtitle"-->
        <!--                            color="gray"-->
        <!--                        >-->
        <!--                            Aangeraden door-->
        <!--                        </AppTitle>-->
        <!--                    </AppHeader>-->

        <!--                    <AppUserGrid-->
        <!--                        class="sm:grid-cols-3 lg:grid-cols-4 xl:grid-cols-2 2xl:grid-cols-2"-->
        <!--                        :users="users.data"-->
        <!--                    />-->
        <!--                </section>-->
        <!--            </div>-->
        <!--        </template>-->
    </TheLayoutApp>
</template>
